import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { viewerConfig } from "./const";

const InvoiceTemplateModal = props => {
  const {
    isOpen,
    toggle,
    template,
    actions,
  } = props;

  const { t } = useTranslation("common");

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      style={{ minWidth: `${viewerConfig.viewerWidth + 53}px`, height: `calc(100vh - 56px)` }}
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody style={{ overflowY: 'auto', height: `calc(100vh - 150px)` }}>
          {template}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          {actions}
        </ModalFooter>
      </div>
    </Modal>
  );
};

InvoiceTemplateModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  template: PropTypes.any,
  actions: PropTypes.any,
};

export default InvoiceTemplateModal;
